export const state = {
  images: [],
  pagination: null,
  isLoading: false
};
